import { FC, useState, memo, useMemo } from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { Modal, Box } from '@mui/material';

const ImageCell: FC<React.PropsWithChildren<GridCellProps>> = ({ dataItem, field }) => {
  const [openModal, setOpenModal] = useState(false);

  const { imageSrc, largeImageSrc } = useMemo(() => {
    const images = dataItem[field];
    
    const imageName = images && images.length > 0 ? images[0] : dataItem.itemNumber ? `${dataItem.itemNumber}.jpg` : '';

    return {
      imageSrc: imageName ? `https://www.bfgsupply.com/img/product/thumb/${imageName}` : '',
      largeImageSrc: imageName ? `https://www.bfgsupply.com/img/product/large/${imageName}` : '',
    };
  }, [dataItem, field]);

  return (
    <td className="grid-img-cell">
      <Modal open={openModal} className="grid-image-modal" onClose={() => setOpenModal(false)}>
        <Box>
          <img
            src={largeImageSrc}
            alt={dataItem.itemName}
            onError={(e) => {
              (e.target as HTMLImageElement).style.visibility = 'hidden';
            }}
          />
          <Box sx={{ color: 'white', textAlign: 'center', fontWeight: 'bold' }}>{dataItem.itemName}</Box>
        </Box>
      </Modal>

      <img
        src={imageSrc}
        onClick={() => setOpenModal(true)}
        className="grid-image"
        alt={dataItem.itemName}
        loading="lazy"
        onError={(e) => {
          (e.target as HTMLImageElement).style.display = 'none';
        }}
      />
    </td>
  );
};

export default memo(ImageCell, (prevProps, nextProps) => {
  return (
    prevProps.dataItem[prevProps.field] === nextProps.dataItem[nextProps.field] &&
    prevProps.dataItem.itemNumber === nextProps.dataItem.itemNumber &&
    prevProps.isSelected === nextProps.isSelected
  );
});
